import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Testing = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">What will I learn in this course?</h1>
          <ul>
            <li>Core Java</li>
            <li>Manual Testing</li>
            <li>Agile</li>
            <li>Scrum – An Agile Methodology</li>
            <li>Software Testing in Agile Environment</li>
            <li>Automation Testing using Selenium WebDriver</li>
            <li>BDD with Cucumber</li>
            <li>Introduction to DevOps tools</li>
          </ul>
          <p><b>Session 1: Core Java</b></p>
          <p>Object-oriented Concepts,Introduction to Java,Java Language Fundamentals,Containment,Inheritance,Polymorphism,Abstract classes, String, Stringbuffer,Interfaces,Packages,Exception Handling,Generics,Collections,Multithreading,File I/O,Lambda Expressions,Functional interfaces,Method References,Default Methods,Optional Class,New Date/Time API,What are streams,Collections and Streams,JUnit Testing</p>
          <p><b>Session 2: Manual Testing</b></p>
          <p>Basics Of Software Application,Development of Software Application,Intro To Software Testing,Process Of Testing,Test Design for Functional Testing, Test Execution, Defect Management,Other Testing Types,Quality and Process Improvement,Getting Equipped To Start, Participatory Activities, Agile Concepts</p>
          <p><b>Session 3: Agile</b></p>
          <p>What is Agile,12 Principles of Agile,Agile Values,Benefits of Agile,Challenges in Agile</p>
          <p><b>Session 4: Scrum – An Agile Methodology</b></p>
          <p>Introduction to Scrum,Scrum Values,Scrum Roles,Scrum Ceremonies and Events,Scrum Terms and Artifacts,Estimation In Agile</p>
          <p><b>Session 5: Software Testing in Agile Environment</b></p>
          <p>Overview,Agile Testing Methodology,Agile Testing Principles,Agile Testing Life Cycle,Planning and Analysis in Agile Testing,Techniques of Agile Testing,Testers Role in Agile,Testing in Waterfall model vs Agile models,Benefits of Agile Testing Methodologies</p>
          <p><b>Session 6: Automation Testing using Selenium WebDriver</b></p>
          <p>Introduction to Test Automation,Selenium IDE,Selenium WebDriver Overview,Locating Elements,Working with Web Elements,Working with Selenium API,Controlling Test Flow,TestNG,Working with Excel,Implementing Frameworks,Selenium Grid</p>
          <p><b>Session 7: BDD with Cucumber</b></p>
          <p>Introduction to BDD,Cucumber Setup,Cucumber basics,Data driven testing with cucumber,Cucumber Features</p>
          <p><b>Session 8: Introduction to DevOps tools</b></p>
          <p>Maven – A Build Management tool, Git, GitHub – A Distributed Version Control Tool,Jenkins – A Continuous Integration Tool</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Testing